// Command Menu component - persistent navigation bar
import React from 'react';

const MENU = [
  'help',
  'about',
  'skills',
  'experience',
  'case-study',
  'projects',
  'education',
  'certifications',
  'contact',
  'resume',
  'theme',
  'clear'
];

const isMac = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform);

const CommandMenu = ({ onCommandClick, activeCommand }) => (
  <div className="command-menu">
    <span className="command-menu-label">commands</span>
    <div className="command-menu-items">
      {MENU.map((cmd) => (
        <button
          key={cmd}
          type="button"
          className={`command-chip${cmd === activeCommand ? ' command-chip-active' : ''}`}
          // Keep focus on the prompt so typing still works after a click.
          onMouseDown={(e) => e.preventDefault()}
          onClick={() => onCommandClick(cmd)}
          title={`Run: ${cmd}`}
        >
          {cmd}
        </button>
      ))}
    </div>
    <button
      type="button"
      className="command-menu-search"
      onClick={() => window.dispatchEvent(new CustomEvent('portfolio:palette'))}
      title="Search commands and resume"
    >
      <kbd>{isMac ? '⌘' : 'Ctrl'}</kbd>
      <kbd>K</kbd>
      <span>search</span>
    </button>
  </div>
);

export default CommandMenu;
